'use strict';

exports.PRODUCT_CAMPAIGN = 'campaign';
exports.SURVEY_NAME_SHORT_LENGTH = 35;


//////////////////
// WEBPACK FOOTER
// ./src/utils/util-constants.js
// module id = 1099
// module chunks = 0